module.exports = __webpack_public_path__ + "static/media/boy-girl_mobile.006edbbd.jpg";